module.exports = __webpack_public_path__ + "static/media/ic_return_complete.4fa7caef.png";